<form #scoresForm="ngForm" (ngSubmit)="saveScores(scoresForm)">
  @if (isLoading()) {
    <app-shimmer-effect />
  } @else {
    <section class="page-heading">
      <div>
        <h4>{{ classData()?.payload?.level_name }}{{ classData()?.payload?.name }}</h4>
        <small>Take class assessment</small>
      </div>

      @if (!hideScoreSheet()) {
        <div class="btn-container">

          <!--      @if (admins.includes(loggedUserRole ?? '')) {-->
          <button
            class="button first-button"
            type="submit"
            [disabled]="isSubmitting() || isLoadingScores() || isLockingScores() || scoresLocked() || scoresFinalized">
            @if (isSubmitting()) {
              <app-loading-indicator />
            } @else {
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.0818 12.2486H2.91626C2.60689 12.2486 2.31018 12.1257 2.09142 11.9069C1.87266 11.6881 1.74976 11.3914 1.74976 11.0821V2.91651C1.74976 2.60713 1.87266 2.31043 2.09142 2.09166C2.31018 1.8729 2.60689 1.75 2.91626 1.75H9.33206L12.2483 4.66627V11.0821C12.2483 11.3914 12.1254 11.6881 11.9067 11.9069C11.6879 12.1257 11.3912 12.2486 11.0818 12.2486Z"
                  stroke-width="1.28316" stroke="white" />
                <path d="M9.91531 12.2486V7.58252H4.08276V12.2486" stroke-width="1.28316" stroke="white" />
                <path d="M4.08276 1.75V4.66627H8.7488" stroke-width="1.28316" stroke="white" />
              </svg>

              <p>Save Scores</p>
            }
          </button>

          <!--      }-->

          <!--      @if (classStudents()?.payload?.length) {-->
          <button
            class="secondary-button"
            type="button"
            (click)="scoresLocked() ? openUnlockPopup() : lockScores()"
            [disabled]="
            isLockingScores() ||
            isLoadingScores() ||
            !hasSavedScores ||
            scoresFinalized ||
            (scoresLocked() ? !canUnlockScores : !canLockScores)
          ">
            @if (isLockingScores()) {
              <app-loading-indicator />
            } @else {
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.49952 5.83252H10.4986C11.1428 5.83252 11.6651 6.35478 11.6651 6.99903V11.0818C11.6651 11.7261 11.1428 12.2483 10.4986 12.2483H3.49952C2.85527 12.2483 2.33301 11.7261 2.33301 11.0818V6.99903C2.33301 6.35478 2.85527 5.83252 3.49952 5.83252Z"
                  stroke-width="1.28316" stroke="white" />
                <path
                  d="M4.66602 5.83278V4.08302C4.66602 3.46426 4.91181 2.87085 5.34934 2.43332C5.78687 1.9958 6.38028 1.75 6.99903 1.75C7.61779 1.75 8.2112 1.9958 8.64872 2.43332C9.08625 2.87085 9.33205 3.46426 9.33205 4.08302V5.83278"
                  stroke-width="1.28316" stroke="white" />
              </svg>

              <p>
                {{
                  scoresFinalized
                    ? 'Scores Finalized'
                    : scoresLocked()
                      ? canUnlockScores
                        ? 'Unlock Scores'
                        : 'Scores Locked'
                      : 'Lock Scores'
                }}
              </p>
            }
          </button>
          <!--      }-->

        </div>
      }
    </section>
  }

  <section class="data-cards">

    <div class="data-card">
      <p>CLASS</p>
      <h6 class="red">{{ classData()?.payload?.name ?? '—' }}</h6>
      <p class="lighter-color">{{ classData()?.payload?.public_id ?? '—' }}</p>
    </div>

    <div class="data-card">
      <p>SUBJECT</p>
      <h6 class="blue">{{ assessmentConfig()?.subject_name ?? '—' }}</h6>
      <p class="lighter-color">{{ assessmentConfig()?.subject_code ?? '—' }}</p>
    </div>

    <div class="data-card">
      <p>STUDENTS</p>
      <h6 class="green">{{ classStudents()?.pagination?.totalElements ?? 0 }}</h6>
      <p class="lighter-color">{{ assessmentConfig()?.component_score_count ?? 0 }} Scores Completed</p>
    </div>

    <div class="data-card">
      <p>SCORE STRUCTURE</p>
      @if (hideScoreSheet()) {
        <h6>-</h6>
      } @else {
        <h6 class="purple">{{ classScoreMaximum }} / {{ examWeight }}</h6>
      }
      <p class="lighter-color">
        {{ scoresLocked() ? 'Scores locked' : 'Scores unlocked' }}
      </p>
    </div>

  </section>

  <section class="boxes">
    <div class="box-one">

      <div class="assessment-overview">
        <div class="assessment-heading">
          <div>
            <img src="/dashboard/chart-icon.svg" alt="chart icon">
          </div>

          <h6>Assessment Overview</h6>
        </div>

        <div class="class-components">
          @for (c of classScoreComponents(); track c.id) {
            <div>
              <h6><span>{{ $index + 1 }}</span> {{ c.component_name }}</h6>
              <small>{{ c.maximum_score | number: '1.0-0' }} Marks</small>
            </div>
          } @empty {
            <div>
              <h6>No assessment components configured</h6>
            </div>
          }
        </div>

        @if (!scoresFinalized) {
          <div class="set-class" (click)="openClassScoreBreakdown()">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path d="M4.99963 3.74951H13.124" stroke-width="1.2499" stroke="black" />
                <path d="M4.99963 7.49951H13.124" stroke-width="1.2499" stroke="black" />
                <path d="M4.99963 11.249H13.124" stroke-width="1.2499" stroke="black" />
                <path d="M1.87488 3.74951H1.88113" stroke-width="1.2499" stroke="black" />
                <path d="M1.87488 7.49951H1.88113" stroke-width="1.2499" stroke="black" />
                <path d="M1.87488 11.249H1.88113" stroke-width="1.2499" stroke="black" />
              </svg>
            </div>

            <p>Set Class Score Breakdown</p>

          </div>
        }

      </div>

      <div class="entry-progress">
        <div class="heading">
          <h6>Entry Progress</h6>

          <small [style.color]="Helpers.getStatusStyle(entryProgress).color">{{ entryProgress }}%</small>
        </div>

        <div class="progress-bar">
          <div [style.width.%]="entryProgress" [style.background]="Helpers.getStatusStyle(entryProgress).color"></div>
        </div>

        <div class="entry-summary">
          <p><span class="complete">{{ completedEntries }}</span>Complete</p>·
          <p><span class="remaining">{{ remainingEntries }}</span>Remaining</p>
        </div>

      </div>

    </div>

    <div class="box-two">
      @if (!hideScoreSheet()) {
        <div class="table-content">
          <div class="student-scores-heading">

            <div>
              <h6>Score Recording Sheet</h6>
              <small>Enter scores in the outlined fields</small>
            </div>

            <div class="filters">
              <input (input)="getClassStudents('search', studentSearch)" [(ngModel)]="studentSearch" type="text"
                     name="studentSearch" id="" placeholder="Search student">
            </div>
          </div>

          <div class="table-wrapper">
            <table class="score-table" [style.--score-cols]="classScoreComponents().length">
              <colgroup>
                <col class="w-student">

                @for (c of classScoreComponents(); track c.id) {
                  <col class="w-score">
                }

                <col class="w-calc">   <!-- class score -->
                <col class="w-score">  <!-- exam score -->
                <col class="w-calc">   <!-- total -->
                <col class="w-grade">  <!-- grade -->
              </colgroup>

              <thead>
              <!-- Row 1: group headers -->
              <tr>
                <th rowspan="2" class="col-student">STUDENT</th>

                <th [attr.colspan]="classScoreComponents().length + 1" class="group group-ca">
                  CONTINUOUS ASSESSMENT · {{ classScoreMaximum }}%
                </th>
                <th class="group exam-col">EXAMINATION</th>
                <th colspan="2" class="group">FINAL RESULT</th>
              </tr>

              <!-- Row 2: individual columns -->
              <tr>
                @for (c of classScoreComponents(); track c.id) {
                  <th class="sub">
                    <p>{{ c.component_name.toUpperCase() }}</p>
                    <p class="sub-max">({{ c.maximum_score | number: '1.0-0' }})</p>
                  </th>
                }

                <th class="sub calculated">
                  <p>CLASS SCORE</p>
                  <p class="sub-max">({{ classScoreMaximum }})</p>
                </th>

                <th class="sub">
                  <p>EXAM SCORE</p>
                  <p class="sub-max">({{ examMaximumScore }})</p>
                </th>

                <th class="sub calculated">
                  <p>TOTAL</p>
                  <p class="sub-max">({{ classScoreMaximum + examWeight }})</p>
                </th>

                <th class="sub calculated">
                  <p>GRADE</p>
                </th>
              </tr>
              </thead>

              <tbody>
                @for (s of classStudents()?.payload; track s.id; let sIndex = $index) {
                  <tr>
                    <td>
                      <div class="student-cell">
                        <!--                    <span class="idx">{{ sIndex + 1 }}</span>-->
                        <div>
                          <p>{{
                              Helpers.fullName({
                                first_name: s.student_last_name,
                                last_name: s.student_first_name
                              })
                            }}</p>
                          <p class="lighter-color">{{ s.student_public_id }}</p>
                        </div>
                      </div>
                    </td>

                    @for (c of classScoreComponents(); track c.id) {
                      <td>
                        <input
                          type="number"
                          min="0"
                          [max]="c.maximum_score"
                          placeholder="—"
                          [name]="'component_' + s.id + '_' + c.id"
                          [ngModel]="componentScores()[scoreKey(s.id, c.id)]"
                          (ngModelChange)="setComponentScore(s.id, c.id, $event)"
                          [disabled]="isLoadingScores() || isLockingScores() || scoresLocked()">
                      </td>
                    }

                    <td class="calculated">
                      <p class="lighter-color">{{ classScoreFor(s.id) }} / {{ classScoreMaximum }}</p>
                    </td>

                    <td>
                      <input
                        type="number"
                        min="0"
                        [max]="examMaximumScore"
                        placeholder="—"
                        [name]="'exam_' + s.id"
                        [ngModel]="examScores()[s.id]"
                        (ngModelChange)="setExamScore(s.id, $event)"
                        [disabled]="isLoadingScores() || isLockingScores() || scoresLocked()">
                    </td>

                    <td class="calculated">
                      <p class="lighter-color">{{ totalScoreFor(s.id) }} / {{ classScoreMaximum + examWeight }}</p>
                    </td>

                    <td class="calculated">
                      <span class="grade-badge">{{ gradeFor(s.id) }}</span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <app-pagination
            [page]="classStudents()?.pagination?.page ?? 0"
            [size]="classStudents()?.pagination?.size ?? 10"
            [totalElements]="classStudents()?.pagination?.totalElements ?? 0"
            [totalPages]="classStudents()?.pagination?.totalPages ?? 0"
            [first]="classStudents()?.pagination?.first ?? true"
            [last]="classStudents()?.pagination?.last ?? false"
            [hasNext]="classStudents()?.pagination?.hasNext ?? false"
            [hasPrevious]="classStudents()?.pagination?.hasPrevious ?? false"
            (pageChange)="loadStudentsPage($event)">
          </app-pagination>

        </div>
      } @else {
        <h4 class="grade-config-error">Grade Configuration has not been set for this class. <br> Contact the School
          Administrator.</h4>
      }
    </div>
  </section>
</form>


@if (setClassBreakdown()) {
  <section class="pop-up">
    <div class="bg" (click)="setClassBreakdown.set(false)"></div>

    <form #classScoreForm="ngForm" (ngSubmit)="setClassScoreComponents(classScoreForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 2.5H11.25V12.5H3.75V2.5Z" stroke="white" stroke-width="1.25" />
            <path d="M5.625 5H9.375M5.625 7.5H9.375M5.625 10H8.125" stroke="white"
                  stroke-width="1.25" stroke-linecap="round" />
          </svg>
        </div>

        <div>
          <h6>Set class score breakdown</h6>
          <small>Marks are scaled to the {{ classScoreMaximum }} class score total</small>
        </div>
      </div>

      <div class="form-container">
        <div class="breakdown-rows">
          @for (row of breakdownRows; track row; let i = $index) {
            <div class="breakdown-row">
              <input
                type="text"
                [name]="'component_name_' + i"
                [(ngModel)]="row.component_name"
                placeholder="Component name"
                required />

              <input
                type="number"
                [name]="'component_maximum_score_' + i"
                [(ngModel)]="row.maximum_score"
                placeholder="Max"
                min="0.01"
                step="0.01"
                required />

              <button
                type="button"
                class="remove-breakdown-row"
                (click)="removeBreakdownRow(i)"
                aria-label="Remove component">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.75 3.75L11.25 11.25M11.25 3.75L3.75 11.25" stroke="currentColor"
                        stroke-width="1.25" stroke-linecap="round" />
                </svg>
              </button>
            </div>
          }
        </div>

        <button type="button" class="add-breakdown-row" (click)="addBreakdownRow()">
          + Add component
        </button>

        <div class="breakdown-summary">
          <div>
            <span>Raw total</span>
            <small>Scaled to {{ classScoreMaximum }} class score</small>
          </div>
          <strong>{{ breakdownTotal }}</strong>
        </div>

        <button [disabled]="isSavingBreakdown()" class="secondary-button" type="submit">
          @if (isSavingBreakdown()) {
            <app-loading-indicator />
          } @else {
            Save Breakdown
          }
        </button>

      </div>
    </form>
  </section>
}

@if (showUnlockPopup()) {
  <section class="pop-up">
    <div class="bg" (click)="cancelUnlock()"></div>

    <form #unlockForm="ngForm" (ngSubmit)="unlockScores()">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.49952 5.83252H10.4986C11.1428 5.83252 11.6651 6.35478 11.6651 6.99903V11.0818C11.6651 11.7261 11.1428 12.2483 10.4986 12.2483H3.49952C2.85527 12.2483 2.33301 11.7261 2.33301 11.0818V6.99903C2.33301 6.35478 2.85527 5.83252 3.49952 5.83252Z"
              stroke="white" stroke-width="1.28316" />
            <path
              d="M4.66602 5.83278V4.08302C4.66602 3.46426 4.91181 2.87085 5.34934 2.43332C5.78687 1.9958 6.38028 1.75 6.99903 1.75C7.61779 1.75 8.2112 1.9958 8.64872 2.43332"
              stroke="white" stroke-width="1.28316" />
          </svg>
        </div>

        <div>
          <h6>Unlock student scores</h6>
          <small>This reason is recorded in the audit log</small>
        </div>
      </div>

      <div class="form-container">
        <textarea
          name="unlockReason"
          id="unlockReason"
          cols="30"
          rows="3"
          required
          [(ngModel)]="unlockReason"
          placeholder="Provide a reason for unlocking these scores..."
          [disabled]="isLockingScores()">
        </textarea>

        <div class="unlock-actions">
          <button
            class="secondary-button"
            type="submit"
            [disabled]="isLockingScores() || !unlockReason.trim()">
            @if (isLockingScores()) {
              <app-loading-indicator />
            } @else {
              Unlock Scores
            }
          </button>
        </div>
      </div>
    </form>
  </section>
}

